<template>
  <full-container>
    <template slot="header">
      <total style="margin-bottom: 16px" />
      <div class="toolbar">
        <el-form inline size="small">
          <el-form-item>
            <metaPicker
              type="platform"
              :value.sync="queryParams.platform"
              clearable
              style="width: 100px"
              @change="onSearch()"
            />
          </el-form-item>
          <el-form-item>
            <el-select
              style="width: 100px"
              clearable
              v-model="queryParams.state"
              placeholder="订单状态"
              @change="onSearch()"
            >
              <el-option
                v-for="item in stateOptions"
                :key="item.value"
                :label="item.text"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              style="width: 220px"
              type="daterange"
              v-model="queryParams.dateSpan"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="onSearch()"
            />
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="queryParams.keyWord"
              clearable
              placeholder="订单号/客户名称"
            >
              <template slot="append">
                <el-button icon="el-icon-search" @click="onSearch()" />
              </template>
            </el-input>
          </el-form-item>
        </el-form>
        <el-button
          v-action="'/api/Mall/Torder/Submit'"
          type="primary"
          size="small"
          @click="$router.push({ path: 'form' })"
          >过单登记</el-button
        >
      </div>
    </template>
    <!--表格-->
    <el-table
      v-loading="loading"
      @expand-change="onExpand"
      :data="datalist.Items"
      height="100%"
    >
      <el-table-column type="expand">
        <div class="expand-cell" slot-scope="{ row }">
          <el-descriptions column="2">
            <el-descriptions-item label="客户联系人"
              >{{ row.Linkman }}{{ row.Linktel }}</el-descriptions-item
            >
            <el-descriptions-item label="打款账号">{{
              row.Bankcard
            }}</el-descriptions-item>
            <el-descriptions-item label="结算方式">
              {{ $utils.meta.format("POClear", row.POClear) }}
            </el-descriptions-item>
            <el-descriptions-item label="备注信息" span="2">{{
              row.Remark
            }}</el-descriptions-item>
            <el-descriptions-item label="经销商合同">
              <template
                v-for="file in row.Files.filter(
                  (x) => x.mode == 'customer-contract'
                )"
              >
                <el-link
                  :key="file.id"
                  type="primary"
                  target="_blank"
                  :href="file.url"
                  >{{ file.name }}</el-link
                >
              </template>
            </el-descriptions-item>
            <el-descriptions-item label="经销商发票">
              <template
                v-for="file in row.Files.filter(
                  (x) => x.mode == 'customer-invoice'
                )"
              >
                <el-link
                  :key="file.id"
                  type="primary"
                  target="_blank"
                  :href="file.url"
                  >{{ file.name }}</el-link
                >
              </template>
            </el-descriptions-item>
            <el-descriptions-item label="采购人合同">
              <template
                v-for="file in row.Files.filter(
                  (x) => x.mode == 'purchaser-contract'
                )"
              >
                <el-link
                  :key="file.id"
                  type="primary"
                  target="_blank"
                  :href="file.url"
                  >{{ file.name }}</el-link
                >
              </template>
            </el-descriptions-item>
            <el-descriptions-item label="采购人发票">
              <template
                v-for="file in row.Files.filter(
                  (x) => x.mode == 'purchaser-invoice'
                )"
              >
                <el-link
                  :key="file.id"
                  type="primary"
                  target="_blank"
                  :href="file.url"
                  >{{ file.name }}</el-link
                >
              </template>
            </el-descriptions-item>
            <el-descriptions-item label="确认文件">
              <template
                v-for="file in row.Files.filter(
                  (x) => x.mode == 'customer-document'
                )"
              >
                <el-link
                  :key="file.id"
                  type="primary"
                  target="_blank"
                  :href="file.url"
                  >{{ file.name }}</el-link
                >
              </template>
            </el-descriptions-item>
            <el-descriptions-item label="付款截图">
              <template
                v-for="file in row.Files.filter(
                  (x) => x.mode == 'payment-screenshot'
                )"
              >
                <el-link
                  :key="file.id"
                  type="primary"
                  target="_blank"
                  :href="file.url"
                  >{{ file.name }}</el-link
                >
              </template>
            </el-descriptions-item>
            <el-descriptions-item label="经办人">{{
              row.Handler
            }}</el-descriptions-item>
            <el-descriptions-item label="商务">{{
              row.Approver
            }}</el-descriptions-item>
          </el-descriptions>
          <records type="Mall-Torder" :id="row.Id" />
        </div>
      </el-table-column>
      <el-table-column label="订单时间" width="100">
        <template slot-scope="{ row }">
          {{ $utils.common.parseTime(row.CreateTime, "{y}-{m}-{d}") }}
        </template>
      </el-table-column>
      <el-table-column prop="Platform" label="平台" min-width="80">
        <template slot-scope="{ row }">
          {{ $utils.meta.format("platform", row.Platform) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="Code"
        label="订单编号"
        width="120"
        show-overflow-tooltip
      />
      <el-table-column
        prop="Customer"
        label="客户单位"
        min-width="250"
        show-overflow-tooltip
      />
      <el-table-column label="订单金额" min-width="100">
        <template slot-scope="{ row }">
          <label class="text-price">{{ row.TotalAmount }}</label>
        </template>
      </el-table-column>
      <el-table-column label="过单点率" min-width="150">
        <template slot-scope="{ row }">
          <el-tag size="mini" effect="plain"
            >平台{{ row.PlatformRate }}%</el-tag
          >
          <el-tag size="mini" effect="plain">公司{{ row.CompanyRate }}%</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="结算金额" min-width="100">
        <template slot-scope="{ row }">
          <label class="text-price text-danger">{{ row.FinalAmount }}</label>
        </template>
      </el-table-column>
      <el-table-column label="状态/操作" width="100">
        <template slot-scope="{ row }">
          <el-dropdown>
            <el-tag size="small" :type="stateColor(row.State)">
              {{ row.StateText }}
              <i class="el-icon-arrow-down" />
            </el-tag>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-action="'/api/Mall/Torder/Submit'"
                :disabled="row.State != 0 && row.State != 1"
                @click.native="$router.push({ path: `form/${row.Id}` })"
                >修改</el-dropdown-item
              >
              <el-dropdown-item
                v-action="'/api/Mall/Torder/Confirm'"
                :disabled="row.State != 0"
                @click.native="onConfirm(row)"
                >确认</el-dropdown-item
              >
              <el-dropdown-item
                v-action="'/api/Mall/Torder/Approve'"
                :disabled="row.State != 1"
                @click.native="onApprove(row)"
                >审核</el-dropdown-item
              >
              <el-dropdown-item
                v-action="'/api/Mall/Torder/Collect'"
                :disabled="row.State != 2"
                @click.native="onCollect(row)"
                >收款</el-dropdown-item
              >
              <el-dropdown-item
                v-action="'/api/Mall/Torder/Complete'"
                :disabled="row.State != 3"
                @click.native="onPayment(row)"
                >打款</el-dropdown-item
              >
              <el-dropdown-item
                v-action="'/api/Mall/Torder/Revoke'"
                :disabled="row.State == -1"
                @click.native="onRevoke(row)"
                >作废</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <el-pagination
      slot="footer"
      background
      :page-size="queryParams.size"
      :total="datalist.TotalCount"
      @current-change="onSearch"
    />
  </full-container>
</template>


<script>
import paymentForm from "./payment.vue";
export default {
  components: {
    total: () => import("./_total.vue"),
    metaPicker: () => import("@/views/system/meta/item/_picker.vue"),
    records: () => import("@/views/system/record/list"),
  },
  data() {
    return {
      loading: false,
      datalist: {},
      queryParams: {
        index: 1,
        size: 20,
      },
      stateOptions: [
        {
          text: "已作废",
          value: -1,
        },
        {
          text: "待确认",
          value: 0,
        },
        {
          text: "已确认",
          value: 1,
        },
        {
          text: "已审定",
          value: 2,
        },
        {
          text: "已打款",
          value: 9,
        },
      ],
    };
  },
  computed: {
    stateColor() {
      return (state) => {
        switch (state) {
          case -1:
            return "info";
          case 0:
            return "primary";
          case 1:
            return "warning";
          case 2:
            return "success";
          case 9:
            return "danger";
          default:
            return null;
        }
      };
    },
  },
  created() {
    this.loadData();
  },
  methods: {
    // 查询参数
    onSearch(val = 1) {
      this.queryParams.index = val;
      this.loadData();
    },
    // 信息列表
    loadData() {
      this.loading = true;
      this.$apis.mall.torder
        .list(this.queryParams)
        .then((res) => {
          res.Items.forEach((element) => {
            element.Files = [];
          });
          this.datalist = res;
        })
        .catch((e) => {
          this.$message.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //展开关闭行
    onExpand(row, rows) {
      if (rows.find((x) => x.Id == row.Id)) {
        this.loadFiles(row);
      }
    },

    //获取附件
    loadFiles(row) {
      this.$apis.system.file
        .list({
          objectId: row.Id,
        })
        .then((res) => {
          row.Files = res;
        });
    },

    //作废
    onRevoke(row) {
      this.$prompt(null, `作废${row.Code}`, {
        inputPlaceholder: "作废原因...",
        center: true,
        callback: (action, { inputValue }) => {
          if (inputValue && action === "confirm") {
            this.$apis.mall.torder
              .revoke({
                id: row.Id,
                msg: inputValue,
              })
              .then(() => {
                this.$message({
                  message: "执行成功，过单信息已作废！",
                  type: "success",
                });
                this.loadData();
              })
              .catch((e) => {
                this.$message.error(e || "系统错误");
              });
          }
        },
      });
    },

    //确认
    onConfirm(row) {
      this.$prompt(null, `确认${row.Code}`, {
        inputType: "textarea",
        inputPlaceholder: "备注信息...",
        distinguishCancelAndClose: true,
        callback: (action, { inputValue }) => {
          if (action == "confirm") {
            this.loading = true;
            this.$apis.mall.torder
              .confirm({
                id: row.Id,
                msg: inputValue,
              })
              .then(() => {
                this.loadData();
              })
              .catch((e) => {
                this.$message.error(e || "系统错误");
              })
              .finally(() => {
                this.loading = false;
              });
          }
        },
      });
    },

    //审核
    onApprove(row) {
      this.$prompt(null, `审核${row.Code}`, {
        confirmButtonText: "同意",
        cancelButtonText: "拒绝",
        inputType: "textarea",
        inputPlaceholder: "审核意见...",
        distinguishCancelAndClose: true,
        callback: (action, { inputValue }) => {
          //判定
          let state = null;
          switch (action) {
            case "confirm": {
              state = true;
              break;
            }
            case "cancel": {
              state = false;
              break;
            }
          }
          //提交
          if (state !== null) {
            this.loading = true;
            this.$apis.mall.torder
              .approve({
                id: row.Id,
                state: state,
                msg: inputValue,
              })
              .then(() => {
                this.loadData();
              })
              .catch((e) => {
                this.$message.error(e || "系统错误");
              })
              .finally(() => {
                this.loading = false;
              });
          }
        },
      });
    },

    //收款
    onCollect(row) {
      this.$prompt(null, `收款${row.Code}`, {
        inputType: "textarea",
        inputPlaceholder: "备注信息...",
        distinguishCancelAndClose: true,
        callback: (action, { inputValue }) => {
          if (action == "confirm") {
            this.loading = true;
            this.$apis.mall.torder
              .collect({
                id: row.Id,
                msg: inputValue,
              })
              .then(() => {
                this.loadData();
              })
              .catch((e) => {
                this.$message.error(e || "系统错误");
              })
              .finally(() => {
                this.loading = false;
              });
          }
        },
      });
    },

    //打款
    onPayment(row) {
      this.$layer.iframe({
        title: `打款${row.Code}`,
        area: ["400px", "auto"],
        content: {
          content: paymentForm,
          parent: this,
          data: {
            id: row.Id,
            bankcard: row?.Bankcard,
            poclear: row?.POClear,
            amount: row.FinalAmount,
            callback: this.loadData,
          },
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.expand-cell {
  padding: 0 58px;
  display: grid;
  grid-template-columns: 2fr 1fr;
  grid-gap: 16px;

  :deep(.el-descriptions-item__label) {
    color: #99a9bf;
    display: inline-block;
    text-align: justify;
    text-align-last: justify;
    width: 6em;
  }
}
</style>
